import type { Resource } from "i18next";

import en_common from "./locales/en/common.json";
import en_home from "./locales/en/home.json";
import en_tech from "./locales/en/tech.json";
import en_products from "./locales/en/products.json";
import en_fleet from "./locales/en/fleet.json";
import en_contact from "./locales/en/contact.json";
import en_fleetio from "./locales/en/fleetio.json";

import es_common from "./locales/es/common.json";
import es_home from "./locales/es/home.json";
import es_tech from "./locales/es/tech.json";
import es_products from "./locales/es/products.json";
import es_fleet from "./locales/es/fleet.json";
import es_contact from "./locales/es/contact.json";
import es_fleetio from "./locales/es/fleetio.json";

import frCA_common from "./locales/fr-CA/common.json";
import frCA_home from "./locales/fr-CA/home.json";
import frCA_tech from "./locales/fr-CA/tech.json";
import frCA_products from "./locales/fr-CA/products.json";
import frCA_fleet from "./locales/fr-CA/fleet.json";
import frCA_contact from "./locales/fr-CA/contact.json";
import frCA_fleetio from "./locales/fr-CA/fleetio.json";

export const resources: Resource = {
  en: {
    common: en_common,
    home: en_home,
    tech: en_tech,
    products: en_products,
    fleet: en_fleet,
    contact: en_contact,
    fleetio: en_fleetio,
  },
  es: {
    common: es_common,
    home: es_home,
    tech: es_tech,
    products: es_products,
    fleet: es_fleet,
    contact: es_contact,
    fleetio: es_fleetio,
  },
  "fr-CA": {
    common: frCA_common,
    home: frCA_home,
    tech: frCA_tech,
    products: frCA_products,
    fleet: frCA_fleet,
    contact: frCA_contact,
    fleetio: frCA_fleetio,
  },
};
